import type { SchemaWithSlotLayout } from '@cli-types/core-engine/schema-reader.js'
import type { Schema } from '@cli-types/core-engine/schema.js'
import { normalizeSchemaFields } from './normalize-schema-fields.js'

export function normalizeSchemaSlotLayout(schema: Schema): Schema {
  const input = schema as SchemaWithSlotLayout
  const { slot: _slot, ...rest } = input

  return {
    ...rest,
    fields: normalizeSchemaFields(input)
  } as Schema
}
